import * as z from "zod";
import { userFacingError } from "../authorization";
import { zql } from "../generatedDrizzleSchema";
import { mutator } from "./mutator";

const deleteServiceAccountSchema = z.object({
  id: z.string(),
});

// Deleting an account cascades to its credentials, grants (as principal and as
// scope), and federation configs via ON DELETE CASCADE. Requires
// service_account:manage on the account.
export const deleteServiceAccount = mutator({
  schema: deleteServiceAccountSchema,
  resolve: {
    serviceAccount: { kind: "serviceAccount", from: "id" },
  },
  permissions: [
    {
      permission: "service_account:manage",
      scopeId: ({ args }) => args.serviceAccount.id,
    },
  ],
  fn: async ({ tx, args: { serviceAccount } }) => {
    // These tables keep RESTRICT references to the account as an actor, so the
    // delete would fail at the database; surface the reason instead. Accounts
    // with history should be disabled, mirroring how users are deactivated.
    const [commit] = await tx.run(
      zql.workflowCommits
        .where("createdByServiceAccountId", serviceAccount.id)
        .limit(1)
    );
    const [branch] = await tx.run(
      zql.workflowBranches.where("serviceAccountId", serviceAccount.id).limit(1)
    );
    const [message] = await tx.run(
      zql.userMessages.where("serviceAccountId", serviceAccount.id).limit(1)
    );
    if (commit || branch || message) {
      throw userFacingError(
        "This service account has workflow history, so it can’t be deleted. Disable it instead to revoke its access."
      );
    }
    await tx.mutate.serviceAccounts.delete({ id: serviceAccount.id });
  },
});
